import S from 'common/service/sanctuary';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import Pagination from 'common/mdc/table/pagination';
import { Primary } from 'common/mdc/layout';
import { func, number, bool } from 'prop-types';
import CollectionWrapper from 'common/mdc/wrappers/collection';
import Icon from 'common/mdc/icon';
import Button from 'common/mdc/button';
import { Actions as FarceActions } from 'farce';

import {
  selectors,
  actions,
} from '@sma/store/job/jobs';

import JobTable from './table';
import BulkActions from './bulkActions';

const messages = defineMessages({
  jobsSummary: {
    id: 'jobs.pagination.summary',
    defaultMessage: '{count, number} {count, plural, one {job} other {jobs}} of {total} displayed',
  },
  createJob: {
    id: 'jobs.pagination.createGroup',
    defaultMessage: 'Create Job',
  },
  noJobs: {
    id: 'jobs.noJobs',
    defaultMessage: 'No jobs found',
  },
  jobsLoading: {
    id: 'jobs.jobsLoading',
    defaultMessage: 'Jobs loading',
  },
  noJobsConfigured: {
    id: 'jobs.noJobsConfigured',
    defaultMessage: 'No jobs has been discovered in system yet',
  },
  noJobsMatches: {
    id: 'jobs.noJobsMatches',
    defaultMessage: 'No jobs due to filters applied',
  },
  jobsPerPage: {
    id: 'jobs.jobsPerPage',
    defaultMessage: 'Jobs per page',
  },
});

const JobPrimary = ({
  jobsContext,
  total,
  loading,
  isSorted,
  toggleSort,
  paginator,
  onPaginationChange,
  clearSelection,
  isSelected,
  select,
  query,
  search,
  onDownload,
  push,
  showCreateJobDialog,
}) => (
  <Primary loading={loading}>
    <CollectionWrapper
      loading={loading}
      context={jobsContext}
      pagination={S.maybeToNullable(S.map(props => (
        <Pagination
          {...props}
          onChange={onPaginationChange}
          itemsPerPage={messages.jobsPerPage}
        />
      ), paginator))}

    tools={(
      <Button onClick={() => showCreateJobDialog(true)}>
        <FormattedMessage {...messages.createJob} />
      </Button>
    )}
      messages={{
        loading: <FormattedMessage {...messages.jobsLoading} />,
        empty: <FormattedMessage {...messages.noJobs} />,
        summary: count => (
          <FormattedMessage
            values={{ count, total }}
            {...messages.jobsSummary}
          />
        ),
        emptyReasons: [
          <FormattedMessage {...messages.noJobsConfigured} />,
          (query || search) && (
            <FormattedMessage
              values={{ query: (
                <ul>
                  {query && (<li>{query}</li>)}
                  {search && (<li>{search}</li>)}
                </ul>
              ) }}
              {...messages.noJobsMatches}
            />
          ),
        ],
      }}
    >{jobs => (
      <JobTable
        jobs={jobs}
        isSelected={isSelected}
        isSorted={isSorted}
        toggleSort={toggleSort}
      />
    )}
    </CollectionWrapper>
  </Primary>
);

JobPrimary.propTypes = {
  total: number.isRequired,
  loading: bool.isRequired,
  isSorted: func.isRequired,
  toggleSort: func.isRequired,
  onPaginationChange: func.isRequired,
  clearSelection: func.isRequired,
  isSelected: func.isRequired,
  select: func.isRequired,
  onDownload: func.isRequired,
};

export default connect(
  state => ({
    jobsContext: selectors.getJobsContext(state),
    total: S.fromMaybe(0, selectors.getTotal(state)),
    loading: selectors.isLoading(state),
    isSorted: selectors.isSorted(state),
    paginator: selectors.getPaginator(state),
    isSelected: selectors.isSelected(state),
    query: selectors.getQuery(state),
    search: selectors.getSearch(state),
  }),
  {
    load: actions.load,
    toggleSort: actions.toggleSort,
    onPaginationChange: actions.paginationChange,
    clearSelection: actions.clearSelected,
    select: actions.setSelected,
    onDownload: actions.download,
    push: FarceActions.push,
    showCreateJobDialog: actions.showCreateJobDialog,
  },
)(JobPrimary);
